import { render, staticRenderFns } from "./goods-cate-modal.vue?vue&type=template&id=3b932274&scoped=true&"
import script from "./goods-cate-modal.vue?vue&type=script&lang=js&"
export * from "./goods-cate-modal.vue?vue&type=script&lang=js&"
import style0 from "./goods-cate-modal.vue?vue&type=style&index=0&id=3b932274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b932274",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b932274')) {
      api.createRecord('3b932274', component.options)
    } else {
      api.reload('3b932274', component.options)
    }
    module.hot.accept("./goods-cate-modal.vue?vue&type=template&id=3b932274&scoped=true&", function () {
      api.rerender('3b932274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/goods-cate-modal.vue"
export default component.exports